import type { GetLightInvoicesResponse } from '@weft/api-definition';
import { GetLightInvoicesResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useLightInvoices(invoicesIds: string[], options?: CustomUseQueryOptions<GetLightInvoicesResponse>) {
  return useQuery(
    ['invoices', ...invoicesIds],
    async () => {
      const api = getPrivateApi();
      const stringifiedInvoicesIds = JSON.stringify(invoicesIds);
      const getLightInvoicesInvoiceResponse = await api.getLightInvoices({ invoicesIds: stringifiedInvoicesIds });

      return GetLightInvoicesResponseSchema.parse(getLightInvoicesInvoiceResponse);
    }, options);
}